import { createI18n } from 'vue-i18n'

function loadLocaleMessages () {
  const locales = import.meta.globEager('./locales/*.json')
  const messages = {}
  
  Object.keys(locales).forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales[`./locales/${locale}.json`]
    }
  })
  return messages
}

export default createI18n({
  locale: import.meta.env.VITE_I18N_LOCALE || 'es',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'es',
  silentTranslationWarn: false,
  messages: loadLocaleMessages()
})
